<div class="voice-offering-selector">
  <header>Velg abonnement</header>
  <mat-form-field appearance="outline" class="form-field-with-background ice-custom-mat-select form-field-margin">
    <mat-select
      id="selectVoiceOffering"
      ngDefaultControl
      [errorStateMatcher]="matcher"
      [formControlName]="MobilePhoneFormControls.NewOfferingId"
    >
      <mat-select-trigger>
        <div class="selected-subscription">
          @if (isManualRegistration && !subscriptionBundleOptions?.length) {
            @if (
              getVasProductFromOffering(selectedManualRegistrationOption) &&
                getMobilePlanProductFromOffering(selectedManualRegistrationOption);
              as mobilePlanProduct
            ) {
              <span [matTooltip]="mobilePlanProduct?.productName || ''">{{ mobilePlanProduct?.productName }}</span>
              <span>{{ mobilePlanProduct.monthlyPrice.price | priceFormat: PriceType.Monthly }}</span>
            } @else {
              <span [matTooltip]="selectedManualRegistrationOption?.name || ''">
                {{ selectedManualRegistrationOption?.name }}
              </span>
              <span>{{ selectedManualRegistrationOption?.monthlyPrice?.price | priceFormat: PriceType.Monthly }}</span>
            }
          } @else {
            <span [matTooltip]="selectedSubscriptionBundleOption?.subscriptionName || ''">
              {{ selectedSubscriptionBundleOption?.subscriptionName }}
            </span>
            <span>{{ selectedBundlePrice | priceFormat: PriceType.Monthly }}</span>
          }
        </div>
      </mat-select-trigger>
      <div class="ice-custom-mat-options">
        @if (isManualRegistration && !subscriptionBundleOptions?.length) {
          @for (offering of manualRegistrationOfferings() | sortBy: 'dataVolume'; track offering.id) {
            <mat-option [value]="offering.id">
              @if (getVasProductFromOffering(offering); as vasProduct) {
                <div class="vas-offering-option">
                  <div>
                    <span>{{ offering.name }}</span>
                    <span>
                      {{ getMobilePlanProductFromOffering(offering).monthlyPrice?.price | priceFormat: PriceType.Monthly }}
                    </span>
                  </div>
                  <div>
                    <span class="vas-product-information">
                      {{ vasProduct.productName }} {{ vasProduct.monthlyPrice?.price.includingVAT > 0 ? '+' : '' }}
                      {{ vasProduct.monthlyPrice?.price | priceFormat: PriceType.OneTime : 'Inkludert' }}
                    </span>
                  </div>
                </div>
              } @else {
                <div class="offering-option">
                  <div class="offering-option-row">
                    <div class="offering-option-name">{{ offering.name }}</div>
                    <div class="offering-option-price">
                      {{ offering.monthlyPrice?.price | priceFormat: PriceType.Monthly }}
                    </div>
                  </div>
                </div>
              }
            </mat-option>
          }
        } @else {
          @for (
            bundleOffering of subscriptionBundleOptions | sortBy: 'subscriptionPriceInformation.price.includingVAT';
            track bundleOffering
          ) {
            <mat-option [value]="bundleOffering.subscriptionOfferingId">
              @if (getVasProductFromOffering(getVoiceSubscriptionOffering(bundleOffering)); as vasProduct) {
                <div class="offering-option">
                  <div class="offering-option-row">
                    <span class="offering-option-name">{{ bundleOffering.subscriptionName }}</span>
                    <span class="offering-option-price">
                      {{
                        getMobilePlanProductFromOffering(getVoiceSubscriptionOffering(bundleOffering))?.monthlyPrice?.price
                          | priceFormat: PriceType.Monthly
                      }}
                    </span>
                  </div>
                  <div class="offering-option-row">
                    <span class="vas-product-information">
                      {{ vasProduct.productName }} {{ vasProduct.monthlyPrice?.price.includingVAT > 0 ? '+' : '' }}
                      {{ vasProduct.monthlyPrice?.price | priceFormat: PriceType.OneTime : 'Inkludert' }}
                    </span>
                    <span class="offering-option-mobilephone-price">
                      tlf. pris {{ bundleOffering.priceInformation.price | priceFormat: PriceType.OneTime }}
                    </span>
                  </div>
                </div>
              } @else {
                <div class="offering-option">
                  <div class="offering-option-row">
                    <div class="offering-option-name">{{ bundleOffering.subscriptionName }}</div>
                    <div class="offering-option-price">
                      {{ bundleOffering.subscriptionPriceInformation?.price | priceFormat: PriceType.Monthly }}
                    </div>
                    @if (
                      bundleOffering.subscriptionPriceInformation?.isDiscounted &&
                      bundleOffering.subscriptionPriceInformation?.discountAmount
                    ) {
                      <div class="offering-option-discount">
                        Kampanje:
                        {{ bundleOffering.subscriptionPriceInformation.discountAmount | priceFormat: PriceType.OneTime }} i
                        rabatt i {{ bundleOffering.subscriptionPriceInformation.discountLength }} mnd
                      </div>
                      <div class="offering-option-mobilephone-price">
                        <span class="original-price">
                          {{ bundleOffering.subscriptionPriceInformation.originalPrice | priceFormat: PriceType.Monthly }}
                        </span>
                      </div>
                    }
                  </div>
                  @if (!isManualRegistration) {
                    <div class="offering-option-row">
                      <div class="offering-option-discount">
                        @if (
                          bundleOffering.subscriptionHasBinding &&
                          bundleOffering.priceInformation?.isDiscounted &&
                          bundleOffering.priceInformation?.discountAmount
                        ) {
                          Få {{ bundleOffering.priceInformation.discountAmount | priceFormat: PriceType.OneTime }} i
                          bindingsrabatt
                        } @else {
                          Ingen binding
                        }
                      </div>
                      <div class="offering-option-mobilephone-price">
                        tlf. pris {{ bundleOffering.priceInformation.price | priceFormat: PriceType.OneTime }}
                      </div>
                    </div>
                  }
                </div>
              }
            </mat-option>
          }
        }
      </div>
    </mat-select>
  </mat-form-field>
  @if (selectedSubscriptionBundleOption && !isRetailPayment()) {
    <div class="least-total-price">
      @if (selectedSubscriptionBundleOption.subscriptionPriceInformation.isDiscounted) {
        <div class="discounted-amount">
          <span class="bundle-option-discount-icon">
            <mat-icon [svgIcon]="IconNames.ice_invoicing" />
          </span>
          <span>
            {{
              selectedSubscriptionBundleOption.subscriptionPriceInformation.discountAmount | priceFormat: PriceType.OneTime
            }}
            rabatt på abonnementet i {{ selectedSubscriptionBundleOption.subscriptionPriceInformation.discountLength }} mnd
          </span>
        </div>
      }
      @if (selectedSubscriptionBundleOption.priceInformation.isDiscounted) {
        <div class="discounted-amount">
          <span class="bundle-option-discount-icon">
            <mat-icon [svgIcon]="IconNames.ice_invoicing" />
          </span>
          <span>
            {{ selectedSubscriptionBundleOption.priceInformation.discountAmount | priceFormat: PriceType.OneTime }} i
            bindingsrabatt
          </span>
        </div>
      }
      <div>
        Minste totalpris:
        {{ minimumTotalPrice | priceFormat: PriceType.OneTime }}
        <div>Inkludert telefon og abonnement</div>
      </div>
    </div>
  }
</div>
